import { render } from "./SelectClientCard.vue?vue&type=template&id=218953b8&ts=true"
import script from "./SelectClientCard.vue?vue&type=script&lang=ts"
export * from "./SelectClientCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__